export const NAVIGATION_ITEM = 'navigationItem';
export const BUTTON = 'button';
export const DROPDOWN_ITEM = 'dropdownItem';

export type ActionSubjectType = typeof BUTTON | typeof NAVIGATION_ITEM | typeof DROPDOWN_ITEM;
